Ext.define('SA.view.sidebar.data.ImportsDataBrowseWindow', {
    alias: 'widget.imports-data-browse-window',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-imports-data-browse-window',
    floating: true,
    plugins: ['sa-arrow', 'close-on-click-outside'],

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-imports-data-browse-window-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-imports-data-browse-window-title',
                    itemId: 'title',
                    tpl: '{.:htmlEncode}'
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'datasets-list'
        }, {
            xtype: 'simple-container',
            cls: 'sa-imports-data-browse-window-result-wrap',

            items: [
                {
                    xtype: 'sa-text-field',
                    clearButton: true,
                    cls: 'sa-imports-data-browse-window-search-field',
                    emptyText: 'Filter',
                    icon: true,
                    ui: 'compact'
                }, {
                    xtype: 'imports-browse-result-list',
                    cls: 'sa-imports-data-browse-window-result-list'
                }, {
                    xtype: 'no-results-message',
                    cls: 'sa-imports-data-browse-window-no-results-message',
                    text: 'No results found. Please edit or remove your filter.'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-imports-data-browse-window-footer'
        }
    ],

    initComponent() {
        this.callParent();

        this.title = this.down('#title');
        this.datasetsList = this.down('datasets-list');
        this.searchField = this.down('sa-text-field');
        this.resultList = this.down('imports-browse-result-list');
        this.noResultsMessage = this.down('no-results-message');
    },

    buildResultComponents(dataset) {
        var datasetAttributes = dataset ? SA.data.UserAttributes.getForDataset(dataset) : [];

        this.resultList.setItems(datasetAttributes.map(({attribute, name}) => ({
            xtype: 'attribute',
            attribute,
            name,
            selected: (this.projectView.getAttributes?.() ?? []).includes(attribute),

            listeners: {
                'select': this.onAttributeSelected,
                scope: this
            }
        })));
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.updateSize, this);

        this.datasetsList.on('select', this.onDatasetSelected, this);

        this.searchField.on('change', this.refreshResults, this, {buffer: 250});
        this.searchField.on('clear', this.refreshResults, this);
    },

    onAttributeSelected(attribute) {
        this.fireEvent('select:attribute', this, attribute);
    },

    onDatasetSelected(list, dataset) {
        this.setDataset(dataset);
    },

    refreshResults() {
        var hasFilter = !!this.searchField.getValue(),
            search = this.searchField.getValue().trim().toLowerCase(),
            filter = attribute => attribute.toLowerCase().includes(search),
            hasResults = () => this.resultList.hasResults();

        this.resultList.setFilter(filter);
        this.noResultsMessage.setVisible(hasFilter && !hasResults());
    },

    refreshTitle(dataset) {
        this.title.update(dataset ? SA.data.Datasets.getName(dataset) : 'My Imported Data');
    },

    setArrowTarget(target) {
        this.getPlugin('sa-arrow').setTarget(target);
    },

    setDataset(dataset) {
        this.datasetsList.setSelected(dataset);

        this.searchField.setDisabled(!dataset);
        this.searchField.clear();

        this.buildResultComponents(dataset);
        this.refreshResults();
    },

    setSelectedVariables(attributes) {
        this.resultList.items.forEach(result => {
          var isSelected = attributes.includes(result.attribute);

          result.setSelected(isSelected);
        });
    },

    setView(view) {
        var country = view.getCountry(),
            datasets = SA.data.UserDatasets.getDatasetsForCountry(country).map(dataset => dataset.id);

        this.datasetsList.setDatasets(datasets);

        this.projectView = view;
    },

    updateSize() {
        var maxWidth = this.datasetsList.isVisible() ? 840 : 660,
            sidebarWidth = SA.Sidebar.getWidth();

        Ext.suspendLayouts();

        this.setHeight(Math.max(300, Ext.dom.Element.getViewportHeight() - 100));
        this.setWidth(Ext.Number.constrain(Ext.dom.Element.getViewportWidth() - sidebarWidth, sidebarWidth, maxWidth));

        Ext.resumeLayouts(true);
    },

    view({arrowTarget, dataset}) {
        this.refreshTitle(dataset);

        this.datasetsList.setVisible(!dataset);

        this.setArrowTarget(arrowTarget);
        this.setDataset(dataset);

        this.updateSize();
    }
});
